export const focusClosestDialog = (target: Element | null = document.activeElement) => {
  target?.closest<HTMLElement>('[role="dialog"]')?.focus({ preventScroll: true });
};
